// File for logic corresponding to header component
import { Component } from 'js-component-framework';
import AriaPopup from 'js-component-framework/lib/plugins/AriaPopup';
import 'images/alleybot-logo.jpg';
import './header.scss';

/**
 * Component for site header
 */
export default class Header extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.initMobileToggle();
  }

  /**
   * Applies AriaPopup module to this.children.target and this.children.controller
   */
  initMobileToggle() {
    const { controller, target } = this.children;
    const { options: { ariapopup: attributes } } = this;

    // Do nothing if there is no controller and target
    if (! controller || ! target) {
      return;
    }

    this.popup = new AriaPopup({
      controller,
      target,
      attributes,
    });
  }
}

